class Nav {
  constructor() {
    this.dom = {
      nav: document.querySelector('.js-nav'),
      lists: document.querySelectorAll('.js-list'),
      items: []
    };

    this.state = {
      isMobile: window.innerWidth < 480,
      isAnimating: false
    };
  }

  resizeHandler = () => {
    if (window.innerWidth < 480 && !this.state.isMobile) this.state.isMobile = true;
    if (window.innerWidth >= 480 && this.state.isMobile) this.state.isMobile = false;
  }
}

export default Nav;
